export default __webpack_public_path__ + "static/media/Missionary's Rerebrace.8da14069.jpg";